import { __decorate } from "tslib";
import * as pathToRegexp from 'path-to-regexp';
import { Component, Vue, Watch } from 'vue-property-decorator';
import breadCrumb from '@/router/lang/page-title';
let default_1 = class default_1 extends Vue {
    breadcrumbs = [];
    onRouteChange(route) {
        // if you go to the redirect page, do not update the breadcrumbs
        if (route.path.startsWith('/redirect/')) {
            return;
        }
        this.getBreadcrumb();
    }
    created() {
        this.getBreadcrumb();
    }
    getBreadcrumb() {
        let matched = this.$route.matched.filter((item) => item.meta && item.meta.title);
        // const first = matched[0]
        // if (!this.isDashboard(first)) {
        //   matched = [
        //     { path: '/dashboard', meta: { title: 'dashboard' } } as RouteRecord
        //   ].concat(matched)
        // }
        this.breadcrumbs = matched.filter((item) => {
            return item.meta && item.meta.title && item.meta.breadcrumb !== false;
        });
        // 来自页面级定义的面包屑
        const record = this.$route.matched.find((m) => m.meta?.breadcrumbs);
        if (record)
            this.breadcrumbs = record.meta?.breadcrumbs;
    }
    isDashboard(route) {
        const name = route && route.meta && route.meta.title;
        return name === 'Dashboard';
    }
    pathCompile(path) {
        // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
        const { params } = this.$route;
        const toPath = pathToRegexp.compile(path);
        return toPath(params);
    }
    handleLink(item) {
        const { path, meta } = item;
        console.log('meta:', meta.disabled);
        // if (redirect) {
        //   this.$router.push(redirect)
        //   return
        // }
        if (!meta.disabled) {
            this.$router.push({
                path: this.pathCompile(path),
                query: item.meta?.query,
            });
        }
    }
};
__decorate([
    Watch('$route')
], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([
    Component({
        name: 'Breadcrumb',
        i18n: {
            sharedMessages: breadCrumb,
        },
    })
], default_1);
export default default_1;
